<div style="display: flex; flex-direction: column; height: 100%">
    <div fxFlex style="height: 100px">
        <mat-toolbar color="primary">
            <mat-toolbar-row>
                <div fxShow="true" fxHide.lt-md fxFlex fxLayout>
                    <div fxFlex>
                        <span class="mat-h3">Aircraft Activity</span>
                    </div>
                </div>
            </mat-toolbar-row>
        </mat-toolbar>
    </div>
    <div style="padding: 10px; height: calc(100% - 100px)">
        <mat-card style="height: 100%; display: flex; flex-direction: column">
            <div style="height: 100px; display: flex; flex-direction: row; justify-content: space-between">
                <kendo-datepicker
                    activeView="year"
                    bottomView="year"
                    format="MMMM yyyy"
                    style="width: 160px; margin: 20px"
                    [(value)]="selectedDate"
                    (valueChange)="onDateChange($event)"
                    [max]="today"
                >
                </kendo-datepicker>
                <button mat-raised-button color="primary" style="margin: 20px" (click)="grid.saveAsExcel()">
                    <mat-icon>download</mat-icon>
                    Export
                </button>
            </div>
            <div style="height: calc(100% - 100px); padding: 10px">
                <kendo-grid #grid="kendoGrid" [data]="flightActivityList" (excelExport)="onExcelExport($event)">
                    <kendo-grid-column field="day" title="Day" [sticky]="true" [width]="60">
                        <ng-template kendoGridFooterTemplate>
                            <div class="footer-value">Totals:</div>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="date" title="Date" [sticky]="true" [width]="100"></kendo-grid-column>
                    @for (aircraft of aircraftList; track aircraft.id) {
                        <kendo-grid-column field="_{{ aircraft.id }}" title="{{ aircraft.registrationMark }}" [style]="{ 'text-align': 'center' }" [width]="50">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                @if (dataItem["_" + aircraft.id]?.hasFlight) {
                                    <span style="color: green; font-weight: bold; font-size: 1.2rem">✓</span>
                                } @else {
                                    <span style="color: red; font-weight: bold; font-size: 1.2rem">✗</span>
                                }
                            </ng-template>
                            <ng-template kendoGridFooterTemplate>
                                <div class="footer-value true-count">
                                    {{ countOccurrences("_" + aircraft.id, true) }}
                                </div>
                                <div class="footer-value false-count">
                                    {{ countOccurrences("_" + aircraft.id, undefined) }}
                                </div>
                            </ng-template>
                        </kendo-grid-column>
                    }
                    <kendo-grid-excel [fileName]="getFileName()">
                        @let matPrimaryColor = "#4050b5";
                        <kendo-excelexport-column field="day" title="Day" [width]="50" [headerCellOptions]="{ background: matPrimaryColor }"></kendo-excelexport-column>
                        <kendo-excelexport-column field="date" title="Date" [width]="120" [headerCellOptions]="{ background: matPrimaryColor }"></kendo-excelexport-column>
                        @for (aircraft of aircraftList; track aircraft.id) {
                            <kendo-excelexport-column
                                field="_{{ aircraft.id }}"
                                title="{{ aircraft.registrationMark }}"
                                [style]="{ 'text-align': 'center' }"
                                [width]="60"
                                [headerCellOptions]="{ background: matPrimaryColor }"
                            >
                                <ng-template kendoExcelExportFooterTemplate>
                                    <div class="footer-value true-count">
                                        {{ countOccurrences("_" + aircraft.id, true) }}
                                    </div>
                                    <div class="footer-value false-count">
                                        {{ countOccurrences("_" + aircraft.id, undefined) }}
                                    </div>
                                </ng-template>
                            </kendo-excelexport-column>
                        }
                    </kendo-grid-excel>
                </kendo-grid>
            </div>
        </mat-card>
    </div>
</div>
